// HFW on stop (Oct 2026), M11: releasing a held order, accepting a reservation or paying a proforma
// is never refused for an on-stop customer, but the 200 response names the on-stop orders among those
// acted on (`onStopOrderNos`) so the screen can say the order is still stopped further on. One place,
// because three screens show it.

/** M11 when the action's response names an on-stop order, or null when it names none. */
export function onStopReleaseWarning(result: { onStopOrderNos?: number[] } | null | undefined): string | null {
  return result?.onStopOrderNos?.length
    ? $localize`This customer is on stop. The order cannot be picked or despatched until the stop is lifted or overridden.`
    : null;
}
